<template>
    <svg
        id="Capa_1"
        fill="#9BA2B6"
        height="24"
        style="enable-background: new 0 0 512 512"
        viewBox="0 0 512 512"
        width="24"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        y="0px"
    >
        <path
            d="M287,0c-8.291,0-15,6.709-15,15v211c0,8.291,6.709,15,15,15h210c8.291,0,15-6.709,15-15C512,101.928,411.072,0,287,0z"
        />
        <path
            d="M314.788,478.367L242,283.275V76c0-8.291-6.709-15-15-15C102.928,61,0,161.928,0,286s102.928,226,227,226
			c27.158,0,53.745-4.819,79.014-14.312C313.763,494.773,317.689,486.13,314.788,478.367z"
        />
        <path
            d="M497,271H287c-4.922,0-9.521,2.417-12.334,6.46c-2.798,4.043-3.442,9.199-1.714,13.813l73.74,197.641
			c1.406,3.721,4.219,6.738,7.852,8.379c3.635,1.653,7.731,1.793,11.484,0.381C453.333,464.817,512,379.164,512,286
			C512,277.709,505.291,271,497,271z"
        />
    </svg>
</template>
<script>
export default {
    name: "DetailReports",
};
</script>
